import React from 'react';
import {createRoot} from 'react-dom/client';

import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './customizations.scss';

import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';

import './index.scss';
import './branding.scss';
import './App.scss';
import './menu_plates_list.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import {ApolloProvider} from '@apollo/react-hooks'
import client from './apolloClient'
import {AuthProvider} from './context/authContext'
import UserContextProvider from "./context/UserContext";

const root = createRoot(document.getElementById('root'));

root.render(
  <ApolloProvider client={client}>
    <AuthProvider>
      <UserContextProvider>

        <React.StrictMode>
          <App />
        </React.StrictMode>

      </UserContextProvider>
    </AuthProvider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
